import { useState, useEffect, useDebugValue } from "react";
import format from "date-fns/format";

import Alerts from "utilities/Alerts";
import http from "utilities/http";

const useReportFetchByDate = (tp = "") => {
	const [type, setType] = useState(tp);

	useDebugValue(`Fetch ${type} report`);
	const oneDay = 1000 * 60 * 60 * 24;
	const currentDate = Date.now();
	const oldDate = currentDate - oneDay * 1; // 1 week old

	const [captureDate, setCaptureDate] = useState([
		new Date(oldDate),
		new Date(currentDate),
	]);
	const [reportList, setReportList] = useState([]);
	const [filteredReportList, setFilteredReportList] = useState([]);
	const [productList, setProductList] = useState([]);
	const [productFilter, setProductFilter] = useState("");
	const [stateFilter, setStateFilter] = useState("");
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		const salesReportUrl = `/report/${type}/date/`;
		if (captureDate && captureDate[0] && captureDate[1]) {
			const fetchDate = `${format(
				captureDate[0].getTime() + oneDay,
				"yyyy-MM-dd"
			)}/${format(captureDate[1].getTime() + oneDay, "yyyy-MM-dd")}`;

			setLoading(true);

			http.get(salesReportUrl + fetchDate)
				.then((response) => {
					const { records } = response.data;

					records.sort(
						(a, b) =>
							new Date(b.date).getTime() -
							new Date(a.date).getTime()
					);

					const tempProductList = [];
					for (const rc of records) {
						if (
							!tempProductList.find(
								(item) =>
									item._id.toString() ===
									rc.productId._id.toString()
							)
						)
							tempProductList.push({
								_id: rc.productId._id,
								name: rc.productId.name,
							});
					}
					setProductList(tempProductList);
					setReportList([...records]);
				})
				.catch((ex) => {
					Alerts.error(ex.message);
				})
				.finally(() => setLoading(false));
		}
	}, [type, captureDate, oneDay]);

	useEffect(() => {
		if (productFilter && stateFilter) {
			const tempFilteredList = [];
			for (const rc of reportList) {
				if (
					rc.productId._id.toString() === productFilter &&
					rc.state.toString() === stateFilter
				)
					tempFilteredList.push(rc);
			}
			setFilteredReportList(tempFilteredList);
		} else if (productFilter) {
			const tempFilteredList = [];
			for (const rc of reportList) {
				if (rc.productId._id.toString() === productFilter)
					tempFilteredList.push(rc);
			}
			setFilteredReportList(tempFilteredList);
		} else if (stateFilter) {
			const tempFilteredList = [];
			for (const rc of reportList) {
				if (rc.state.toString() === stateFilter)
					tempFilteredList.push(rc);
			}
			setFilteredReportList(tempFilteredList);
		} else {
			setFilteredReportList(reportList);
		}
	}, [productFilter, stateFilter, reportList]);

	return {
		filteredReportList,
		productList,
		setProductFilter,
		setStateFilter,
		loading,
		captureDate,
		setCaptureDate,
		hasData: reportList.length > 0,
		type,
		setType,
	};
};

export default useReportFetchByDate;
